import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgFor, NgIf } from "@angular/common";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import swal from "sweetalert2";
import { Cliente } from "src/app/shared/model/ajustesUsuario/cliente.model";
import { SegmentoCliente } from "src/app/shared/model/ajustesUsuario/segmento.cliente";
import { TamanioCliente } from "src/app/shared/model/ajustesUsuario/tamanio.cliente";
import { TipoCliente } from "src/app/shared/model/ajustesUsuario/tipo.cliente";
import { NotCopyPasteDirective } from "../../utilerias/directives/not-copy-paste.directive";
import { SoloNumeroEnteroDirective } from "../../utilerias/directives/solo-numero-entero.directive";
import { GestionclientesService } from "../gestionclientes.service";

type ClienteListState = {
  currentPage?: number;
  searchTerm?: string;
};

@Component({
  selector: "app-addclientemodal",
  standalone: true,
  templateUrl: "./addclientemodal.component.html",
  styleUrls: ["./addclientemodal.component.css"],
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    NotCopyPasteDirective,
    SoloNumeroEnteroDirective,
  ],
})
export class AddclientemodalComponent implements OnInit {
  datosform!: FormGroup;
  client: Cliente = new Cliente();
  listTipos: TipoCliente[] = [];
  listSegmentos: SegmentoCliente[] = [];
  listTamanios: TamanioCliente[] = [];
  esProspectoRfc = false;
  esProspectoRepresentante = false;
  isEditMode = false;
  isSaving = false;
  tituloOperacion = "Alta";
  private readonly listRoute = "/CLIENTES/GESTION_CLIENTES";
  private listState: ClienteListState | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formbuilder: FormBuilder,
    private clienteService: GestionclientesService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (!this.initializeRouteContext()) {
      return;
    }

    this.formdata();
    this.applyProspectState();
    queueMicrotask(() => {
      this.cdr.detectChanges();
    });
  }

  consultaTipos(): void {
    const tipo = new TipoCliente();
    tipo.estatus = "ACTIVO";

    this.clienteService.consultaTipos(tipo).subscribe((res) => {
      this.listTipos = Array.isArray(res?.list) ? res.list : [];

      if (!this.client.idtipo && this.listTipos.length === 1) {
        this.client.idtipo = this.listTipos[0].id;
        this.datosform.controls.tipo.setValue(this.client.idtipo);
      }

      this.cdr.detectChanges();
    });
  }

  consultaSegmento(): void {
    const segmento = new SegmentoCliente();
    segmento.estatus = "ACTIVO";

    this.clienteService.consultaSegmento(segmento).subscribe((res) => {
      this.listSegmentos = Array.isArray(res?.list) ? res.list : [];

      if (!this.client.idsegmento && this.listSegmentos.length === 1) {
        this.client.idsegmento = this.listSegmentos[0].id;
        this.datosform.controls.segmento.setValue(this.client.idsegmento);
      }

      this.cdr.detectChanges();
    });
  }

  consultaTamanio(): void {
    const tam = new TamanioCliente();
    tam.estatus = "ACTIVO";

    this.clienteService.consultaTamanio(tam).subscribe((res) => {
      this.listTamanios = Array.isArray(res?.list) ? res.list : [];

      if (!this.client.idtamanio && this.listTamanios.length === 1) {
        this.client.idtamanio = this.listTamanios[0].id;
        this.datosform.controls.tam.setValue(this.client.idtamanio);
      }

      this.cdr.detectChanges();
    });
  }

  saveClient() {
    if (this.datosform.invalid || this.isSaving) {
      this.datosform.markAllAsTouched();
      swal.fire({
        text: "No se permite dejar campos vacíos ni con errores.",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
        icon: "error",
      });
      return;
    }

    this.isSaving = true;
    this.client.idProyecto = (this.client.idProyecto || "").toUpperCase();

    this.clienteService.saveUpdateCLient(this.client).subscribe({
      next: (res) => {
        this.isSaving = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        // 00002: el servidor rechazo el guardado (cliente de otra empresa o
        // sesion sin empresa) y trae el motivo.
        if (res?.pCodRetorno === "00002") {
          swal.fire({
            text: res.pMensaje || "No fue posible guardar la información del cliente.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
            icon: "error",
          });
          return;
        }
        swal
          .fire({
            text: this.isEditMode
              ? "Cliente actualizado exitosamente."
              : "Cliente insertado exitosamente.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
            icon: "success",
          })
          .then(() => this.navigateBackToList());
      },
      error: () => {
        this.isSaving = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        swal.fire({
          text: "No fue posible guardar la información del cliente.",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-danger",
          },
          icon: "error",
        });
      },
    });
  }

  validar(){
    console.log("datosform.invalid", this.datosform.invalid)
    console.log("isSaving", this.isSaving)
//     console.table(
//   Object.entries(this.datosform.controls)
//     .filter(([, control]) => control.invalid)
//     .map(([nombre, control]) => ({
//       nombre,
//       valor: control.value,
//       errores: control.errors,
//     }))
// );
  }

  formdata() {
    this.datosform = this.formbuilder.group({
      rSocial: [this.client.razonsocial || "", [Validators.required]],
      rfc: [this.client.rfc || "", this.getRfcValidators()],
      represent: [this.client.representante || ""],
      email: [this.client.email || "", [Validators.required, Validators.email]],
      tel: [this.client.telefono || ""],
      tipo: [
        this.client.idtipo || "",
        this.isEditMode ? [Validators.required] : [],
      ],
      segmento: [
        this.client.idsegmento || "",
        this.isEditMode ? [Validators.required] : [],
      ],
      tam: [
        this.client.idtamanio || "",
        this.isEditMode ? [Validators.required] : [],
      ],
      forma: [
        this.client.formacontacto || "",
        this.isEditMode ? [Validators.required] : [],
      ],
      ref: [this.client.comentarios || "", this.isEditMode ? [Validators.required] : []],
      nombreContacto: [this.client.nombreContacto || "", [Validators.required]],
      extensionTel: [
        this.client.extensionTel || "",
      ],
      idProyecto: [
        this.client.idProyecto || "",
        this.isEditMode ? [] : [Validators.required],
      ],
      nombre_corto: [
        this.client.nombre_corto || "",
        [Validators.required, Validators.pattern("^[a-zA-Z0-9]+$")],
      ],
      esProspecto: [this.client.esProspecto ?? 0],
    });

    if (this.isEditMode) {
      this.datosform.controls.nombre_corto.disable();
    }

    this.consultaTipos();
    this.consultaSegmento();
    this.consultaTamanio();
  }

  onNoClick(): void {
    this.navigateBackToList();
  }

  onRadioCompromisoChange() {
    this.applyProspectState();
  }

  get operationDescription(): string {
    return this.isEditMode
      ? "Ajuste datos comerciales y operativos sin salir del flujo de gestión."
      : "Registre un nuevo cliente con la misma lógica visual y operativa del módulo.";
  }

  get clientePreview(): string {
    return this.client.razonsocial?.trim() || "Pendiente de captura";
  }

  private initializeRouteContext(): boolean {
    this.listState = (history.state?.listState as ClienteListState) || null;
    this.isEditMode = this.route.snapshot.paramMap.has("id");
    const clienteState = history.state?.cliente as Cliente | undefined;

    if (this.isEditMode) {
      if (!clienteState) {
        queueMicrotask(() => {
          swal
            .fire({
              title: "Información no disponible",
              text: "Seleccione nuevamente el cliente desde la gestión para editarlo.",
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-success",
              },
              confirmButtonText: "Aceptar",
              icon: "info",
            })
            .then(() => this.navigateBackToList());
        });
        return false;
      }

      this.client = this.hydrateCliente(clienteState);
      this.tituloOperacion = "Edición";
      return true;
    }

    this.client = new Cliente();
    this.client.esProspecto = 0;
    this.tituloOperacion = "Alta";
    return true;
  }

  private applyProspectState(): void {
    const rfcControl = this.datosform?.get("rfc");

    if (!rfcControl) {
      return;
    }

    if (this.client.esProspecto === 1) {
      rfcControl.clearValidators();
      this.esProspectoRepresentante = true;
      this.esProspectoRfc = true;
    } else {
      rfcControl.setValidators(this.getRfcValidators());
      this.esProspectoRepresentante = false;
      this.esProspectoRfc = false;
    }

    rfcControl.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  private getRfcValidators() {
    if (this.client.esProspecto === 1) {
      return [];
    }

    return this.isEditMode
      ? [
          Validators.required,
          Validators.pattern(
            "^[A-ZÑ&]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2,3}$"
          ),
        ]
      : [
          Validators.minLength(12),
          Validators.maxLength(13),
          Validators.pattern(
            "^[A-ZÑ&]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2,3}$"
          ),
        ];
  }

  private hydrateCliente(source: Cliente): Cliente {
    return Object.assign(new Cliente(), source || {});
  }

  private navigateBackToList(): void {
    this.router.navigate([this.listRoute], {
      state: this.listState ? { listState: this.listState } : undefined,
    });
  }
}
